import React from "react";
import PropTypes from "prop-types";
import Markdown from "../../../../common/components/Markdown";
import Loading from "../../../../common/components/Loading";

const GeneratedAnswerBody = ({ answer, contentFormat, isStreaming }) => {
  if (contentFormat === "text/plain") {
    return (
      <pre className="body body-plain">
        {answer}
        {<Loading show={isStreaming} />}
      </pre>
    );
  }

  if (contentFormat === "text/markdown") {
    return (
      <div className="body">
        <Markdown text={answer} />
        <Loading show={isStreaming} />
      </div>
    );
  }

  return null;
};

GeneratedAnswerBody.propTypes = {
  answer: PropTypes.string,
  contentFormat: PropTypes.oneOf(["text/markdown", "text/plain"]),
  isStreaming: PropTypes.bool
};

export { GeneratedAnswerBody };
